<form data-testid="adx-booking-hotel-info-form" class="template-form adx-booking-hotel-info-form">
    <div data-testid="adx-booking-hotel-info-main-div" class="filter__fields">
        <mat-card class="mat-elevation-z8">
            <mat-card-content>
                <mat-grid-list data-testid="adx-booking-hotel-info-grid-list" [cols]="2" gutterSize="10px" rowHeight="90">
                    <mat-grid-tile data-testid="adx-booking-hotel-info-chain-code-grid-tile">
                        <read-only-form-field title="Chain Code" testId="adx-booking-hotel-info-chain-code" value="{{hotelProperty?.chainCode}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-booking-hotel-info-hotel-name-grid-tile">
                        <read-only-form-field title="Hotel Name" testId="adx-booking-hotel-info-hotel-name" value="{{hotelProperty?.hotelName}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-booking-hotel-info-hotel-property-id-grid-tile">
                        <read-only-form-field title="Hotel Property Id" testId="adx-booking-hotel-info-hotel-property-id" value="{{hotelProperty?.hotelPropertyId}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-booking-hotel-info-interface-id-grid-tile">
                        <read-only-form-field title="Interface Id" testId="adx-booking-hotel-info-interface-id" value="{{hotelProperty?.interfaceId}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-booking-hotel-info-address-line1-grid-tile">
                        <read-only-form-field title="Address Line 1" testId="adx-booking-hotel-info-address-line1" value="{{hotelProperty?.addressLine1}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-booking-hotel-info-address-line2-grid-tile">
                        <read-only-form-field title="Address Line 2" testId="adx-booking-hotel-info-address-line2" value="{{hotelProperty?.addressLine2}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-booking-hotel-info-city-grid-tile">
                        <read-only-form-field title="City" testId="adx-booking-hotel-info-city" value="{{hotelProperty?.city}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-booking-hotel-info-province-grid-tile">
                        <read-only-form-field title="Province" testId="adx-booking-hotel-info-province" value="{{hotelProperty?.province}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-booking-hotel-info-zip-code-grid-tile">
                        <read-only-form-field title="Zip Code" testId="adx-booking-hotel-info-zip-code" value="{{hotelProperty?.zipCode}}" />
                    </mat-grid-tile>
                    <mat-grid-tile data-testid="adx-booking-hotel-info-country-grid-tile">
                        <read-only-form-field title="Country" testId="adx-booking-hotel-info-country" value="{{hotelProperty?.country?.name}}" />
                    </mat-grid-tile>
                </mat-grid-list>
            </mat-card-content>
        </mat-card>
    </div>
</form>
